
export const getCrashOverview = {
    variable: '$request: CrashInfoRequest!',
    query: `
    crashEvents(request: $request) {
        total
        crashEvents {
            crashName
            crashEventsCount
            affectedUsers
            lastOccurred
      }
    }`
};

export const getPerformanceErrorOverview = {
    variable: '$request: PerformanceErrorInfoRequest!',
    query: `
    performanceErrorOverview(request: $request) {
        total
        performanceEvents {
            errorName
            errorEventsCount
            affectedUsers
            lastOccurred
      }
    }`
};

export const getPerformanceErrorSummury = {
    variable: '$request: PerformanceErrorInfoRequest!',
    query: `
    performanceErrorSummary(request: $request) {
        total
        performanceErrorEvents {
            eventId
            userId
            device
            appVersion
            osVersion
            lastOccurred
      }
    }`
};

export const getCrashEventsOverview = {
    variable: '$request: CrashInfoRequest!',
    query: `
    crashLogsSummary(request: $request) {
        total
        crashes {
            crashId
            userId
            device
            appVersion
            osVersion
            lastOccurred
        }
    }`
};
export const getCrashIdSummary = {
    variable: '$crashId: ID!',
    query: `
    crashByID(crashId: $crashId) {
            serviceId
            crashName
            appVersion
            stackTrace
            cpuUsage
            memoryUsage
            serviceName
            timeStamp
            os
    }`
};
export const performanceErrorDetails = {
    variable: '$eventId: ID!',
    query: `
    performanceErrorDetailsByID(eventId: $eventId) {
        appVersion
        platformName
        os
        endpointName
        host
        device
        status
        country
        statusCode
        userId
        requestTime
        responseTime
        requestPayloadSize
        responsePayloadSize
    }`
};
export const getHttpReqOverview = {
    variable: '$request: MobilePerfHttpRequest!',
    query: `
    topHttpRequest(request: $request) {
        mobileHttpMetas {
          endpointName
          requests
          requestsPerMin
          responseTime
          errorRate
        }
        total
    }`
};

// TODO: Query needs to be updated

export const gethttpRequestsOverview = {
    variable: '$request: PerformanceInfoRequest!',
    query: `
    performanceLogsSummary(request: $request) {
        total
        performance {
            performanceId
            userId
            device
            appVersion
            osVersion
            lastOccurred
        }
    }`
};
export const getHttpReqSummary = {
    variable: '$request: MobilePerfHttpRequest!',
    query: `
    endpointInfoMobile(request: $request) {
        endpointName
        requests
        requestsPerMin
        responseTime
        errorRate
        requestsPerMin
        requestedLocation
        requestedDevice
        requestedAppVersion
    }`
};

export const heatMapValues = {
    variable: ['$request: MobileCountryRequest!'],
    query: `crashByCountry(request: $request) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
      }`
};


export const heatMapValuesMobileCompare = {
    variable: ['$request:  MobileCountryRequest!, $requestCompared:  MobileCountryRequest!'],
    query: `crashByCountry(request: $request) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
}
        compared: crashByCountry(request: $requestCompared) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
}`
};

export const getCrashInfoByCountry = {
    variable: ['$request: MobileCountryRequest!'],
    query: `crashInfoByCountry(request: $request) {
        mobileCrashInfoByCountry {
            countryName
            countryCode
            noOfCrashes
            noOfAffectedUsers
        }
      }`
};
export const getPerformanceInfoByCountry = {
    variable: ['$request: MobileCountryRequest!'],
    query: `performanceInfoByCountry(request: $request) {
        mobilePerformanceInfoByCountry {
            countryName
            countryCode
            errorRatePercent
            noOfRequests  
            avgHttpResponseTime
        }
        total 
      }`
};

export const getInfoByCountry = {
    variable: '$request: MobileCountryRequest!',
    query: `infoByCountry(request: $request) {
        performances {
            numberOfRequest
            errorPercent
            httpResponse
            avgLoadTime
        }
        crashes {
            totalNoOfCrashes
            mostCrashedDevice
            crashFreeUsersPercent
            mostCrashedDevicePercent
            mostCrashedOS
            mostCrashOSPercent
            mostCrashedAppVersion
            mostCrashedAppVersionPercent
        }
    }`
};

export const performanceHeatMapValues = {
    variable: ['$request: MobileCountryRequest!'],
    query: `performanceByCountry(request: $request) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
      }`
};

export const performanceHeatMapValuesCompare = {
    variable: ['$request:  MobileCountryRequest!, $requestCompared:  MobileCountryRequest!'],
    query: `performanceByCountry(request: $request) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
}
        compared: performanceByCountry(request: $requestCompared) {
        mobileErrorByCountries {
            countryCode
            errorCount
        }
}`
  };

export const getDashCrashStats = {
    variable: ['$request: MobileDashboardRequest!'],
    query: `crashesKPIs(request: $request) {  
        totalNoOfCrashes
        crashesNpm
        crashFreeUsersPercent
        liveCrashes
        crashesByOs {
            key
            value
        }
    }`
};

export const getDashPerformanceStats = {
    variable: ['$request: MobileDashboardRequest!'],
    query: `performanceKPIs(request: $request) {  
        numberOfRequest
        errorPercent
        httpResponse
        avgLoadTime
    }`
};


export const getDashDeviceUsageStats = {
  variable: ['$request: MobileDashboardRequest!'],
  query: `usagesInfoForMobileDashboard(request: $request) {
    install{
        ios
        android
    }
    topDevices{
        key
        value
    }
    appUsagesTopVersions{
        android {
            key
            value
        }
        ios {
            key
            value
        }
    }
}`
};

export const getDashUsageKpisStats = {
  variable: ['$request: MobileDashboardRequest!'],
  query: `usagesInfoForMobileDashboard(request: $request) {
        appUsagesKPIs {
            users
            usersPerMin
            sessions
            sessionsPerMin
            launches
            launchesPerMin
        }
  }`
};

export const crashDetailsSelectedCountry = {
    variable: ['$request: MobileCountryRequest!'],
    query: `crashInfoSelectedCountry(request: $request) {
        crashInfoByCities {
            cityName
            noOfCrashes
            noOfAffectedUsers
        }
        countryCode
        countryName
        noOfCrashes
        noOfAffectedUsers
      }`
};

export const performanceDetailsSelectedCountry = {
    variable: ['$request: MobileCountryRequest!'],
    query: `perfInfoSelectedCountry(request: $request) {
        perfInfoByCities {
            cityName
            noOfRequests
            errorPercent
            avgResponseTime
        }
        countryCode
        countryName
        noOfRequests
        errorPercent
        avgResponseTime
      }`
};